export const INITIAL_STATE_CUSTOMER = {
  id: null,
  nome: null,
  cpfCnpj: null,
  rg: null,
  endereco: null,
  numero: null,
  complemento: null,
  bairro: null,
  cidade: null,
  uf: null,
  ibge: null,
  cep: null,
  email: null,
  telefone: null,
  celular: null,
  dataNascimento: null,
  observacao: null,
  ie: null,
  contribuinte: "9",
  consumidor_final: "1",
  status: "ativo",
}

export const INVALID_FIELDS_CUSTOMER = {
  nome: "",
  cpfCnpj: "",
  cidade: "",
  uf: "",
  cep: "",
}